// statsSlice.js

import { createSlice } from "@reduxjs/toolkit";
import { getMonthlyPerformanceReport } from "./statsActions";

const initialState = {
  monthlyReportData: null,
  clinics: [], // Add clinics slice
  loading: false,
  error: null,
  responseData: [],
  clinicsList: [],
  organisationList: [],
  clinicsLevelList: [],
  patientsOverview: [], // Corrected the state name
};

const statsSlice = createSlice({
  name: "stats",
  initialState,
  reducers: {
    // Add any additional reducers if needed
    updateClinicsList: (state, action) => {
      state.clinicsList = action.payload || [];
    },
    updateOrganisationList: (state, action) => {
      state.organisationList = action.payload || [];
    },
    updateClinicsLevelList: (state, action) => {
      state.clinicsLevelList = action.payload || [];
    },
    updatePatientsOverview: (state, action) => {
      state.patientsOverview = action.payload || []; // Corrected the state name
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMonthlyPerformanceReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMonthlyPerformanceReport.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.responseData = action.payload || [];
        // Add any additional state updates if needed
      })
      .addCase(getMonthlyPerformanceReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "An error occurred";
      });
  },
});

export const { /* Additional reducers, if any */ updateClinicsList, updateClinicsLevelList, updateOrganisationList, updatePatientsOverview } = statsSlice.actions;
export default statsSlice.reducer;
